import { useState, useEffect, useCallback } from 'react'
import { gameApi } from '../api/endpoints'
import { GuessNumberStatus, GuessResult, GameRecord } from '../types'

export function useGuessNumber() {
  const [status, setStatus] = useState<GuessNumberStatus | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchStatus = useCallback(async (opts?: { silent?: boolean }) => {
    try {
      if (!opts?.silent) setLoading(true)
      setError(null)
      const data = await gameApi.getGuessNumberStatus()
      setStatus(data)
    } catch (err: any) {
      setError(err.response?.data?.message || 'خطا در بارگذاری وضعیت بازی')
    } finally {
      if (!opts?.silent) setLoading(false)
    }
  }, [])

  const submitGuess = useCallback(async (guessNumber: string) => {
    setError(null)
    try {
      const result = await gameApi.submitGuess(guessNumber)
      if (result) {
        setStatus((prev) =>
          prev
            ? { ...prev, attempts_remaining: result.attempts_left }
            : prev
        )
      }
      await fetchStatus({ silent: true })
      return result
    } catch (err: any) {
      const msg = err.response?.data?.message || 'خطا در ثبت حدس'
      setError(msg)
      throw new Error(msg)
    }
  }, [fetchStatus])

  const fetchWinners = useCallback(async () => {
    try {
      const res = await gameApi.getGuessNumberWinners()
      return res.winners
    } catch {
      return []
    }
  }, [])

  useEffect(() => {
    fetchStatus()
  }, [fetchStatus])

  return { status, loading, error, submitGuess, fetchWinners, refetch: fetchStatus }
}
